import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const CloseRound = (props: SvgProps) => (
  <Svg width={120} height={120} viewBox="0 0 90 90" {...props}>
    <Path d="M35.5 10.4c-10.7 3.4-18.6 10.2-23.2 20.1-2.4 5.1-2.8 7.3-2.8 14.5s.4 9.4 2.8 14.6c13 28.2 52.2 28.1 65.4-.1 2.4-5.1 2.8-7.3 2.8-14.5s-.4-9.4-2.8-14.5c-3-6.5-8.1-12.4-13.8-16-7.8-5-19.9-6.8-28.4-4.1zm4.2 24.8 5.3 5.2 5.4-5.3c5.5-5.4 8.7-6.4 9.4-2.7.3 1.2-1.5 3.8-4.9 7.2L49.6 45l5.3 5.4c5.4 5.5 6.4 8.7 2.7 9.4-1.2.3-3.8-1.5-7.2-4.9L45 49.6l-5.4 5.3c-3.4 3.4-6 5.2-7.2 4.9-3.7-.7-2.7-3.9 2.7-9.4l5.3-5.4-5.2-5.3c-4.9-4.9-6.1-7.4-4.5-9 1.6-1.6 4.1-.4 9 4.5z" />
  </Svg>
);
export default CloseRound;
